const initialState = {
    serviceIdSelected: {},
    imcNameSelected: {},
    selectedStageId: {},
    triggerUseEffect: {},
    crcTaskPickerEmail: '',
    crcPickerEmail: ''
};

const serviceCheckListReducer1 = (state = initialState, action) => {
    switch (action.type) {
        case 'setSelectedServiceId':
            return {
                ...state,
                serviceIdSelected: action.payload,
            };
        case 'setSelectedStageId':
            return {
                ...state,
                selectedStageId: action.payload,
            };
        case 'getCRCTaskPickerEmail':
            return {
                ...state,
                crcTaskPickerEmail: action.payload,
            };
        case 'getcrcPickerEmail':
            return {
                ...state,
                crcPickerEmail: action.payload,
            };
        case 'setSelectedImc':
            return {
                ...state,
                imcNameSelected: action.payload,
            };
        case 'triggerUseEffect':
            return {
                ...state,
                triggerUseEffect: action.payload,
            };


        default:
            return state;
    }
};

export default serviceCheckListReducer1;
